<template>
  <div class="col-12">
    <div class="card p-5 radius-20 w-100 full-h-card">
      <div class="card-body">
        <div class="preloader js-preloader text-center">
          <img :src="imagePath" class="preloader-image" alt="Loading...">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      enabledSportsSite: {
        type: String,
        required: true
      }
    },
    computed: {
      imagePath() {
        if (this.enabledSportsSite === 'Soccer') {
          return require('../../assets/images/Timbits-Soccer-GIF-V2.1.gif');
        } else {
          return require('../../assets/images/Timbits-Hockey-Animated-GIF.gif');
        }
      }
    }
  };
</script>

<style scoped>
  .preloader-image {
    width: 650px;
    max-width: 100%;
    margin-top: 150px;
  }

  @media (max-width: 767.98px) {
    .preloader-image {
      margin-top: 40px;
    }
  }
</style>
